import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { config } from "@/config";
import { clearToken } from "@/store/slices/auth.slice";
import type { RootState } from "@/store/store";

const baseQuery = fetchBaseQuery({
    baseUrl: config.API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).auth.token;
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth: typeof baseQuery = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (result.error?.status === 401) {
        api.dispatch(clearToken());
    }
    return result;
};

export const rootApi = createApi({
    tagTypes: ["Department", "Team", "Individual", "Project", "Booking", "Timeline"],
    baseQuery: baseQueryWithReauth,
    endpoints: () => ({}),
});
